import React from "react";
import { websiteEditorFeedEmptyMessage } from "../../../Screens/DashboardView/MasterTemplateEditor/websiteEditorFeedEmptyMessage";

/**
 * Editor-only empty feed placeholder. Public surfaces should return null instead
 * so the section is not visible when there is no data.
 */
export function FeedSectionEmptyState({
  title,
  designTokens,
  message = websiteEditorFeedEmptyMessage("posts"),
}: {
  title?: string;
  designTokens?: { primaryFontFamily?: string };
  message?: string;
}) {
  const label = String(title || "").trim();
  return (
    <div className="reels-wrapper mte-lib-feed-empty" data-feed-empty="true">
      {label ? (
        <div className="mainDiv">
          <p
            className="component-name"
            style={{
              fontFamily: designTokens?.primaryFontFamily,
              cursor: "auto",
            }}
          >
            {label}
          </p>
        </div>
      ) : null}
      <div className="mte-we-ghost-empty mte-lib-feed-empty-msg">{message}</div>
    </div>
  );
}
